import * as React from 'react';

const ResultadoAgrupadoPorGrupo = ({ doc, indexDoGrupo, depthOfNode }) => {
  const { resultadoAgrupadoPorGrupo } = doc;
  let pontuacao = 0;
  let pontuacaoMaxima = 0;
  if (resultadoAgrupadoPorGrupo !== null) {
    pontuacao = resultadoAgrupadoPorGrupo.pontuacao;
    pontuacaoMaxima = resultadoAgrupadoPorGrupo.pontuacaoMaxima;
  } else {
    pontuacao = 0;
    pontuacaoMaxima = 0;
  }

  const resultadoDoGrupoEmPorcentagem = ((100 * pontuacao) / pontuacaoMaxima).toFixed(2);

  const handleBackgroundColor = (index) => index % 2 === 0 ? '#efefef' : '#ffffff';
  return (
    <React.Fragment>
      <tr style={{ backgroundColor: handleBackgroundColor(indexDoGrupo) }}>
        <td className='border-0' style={{ paddingLeft: `${depthOfNode}rem` }}>{doc.nome}</td>
        <td className='border-0'>
          {
            pontuacao === 0
              ? 'NA'
              : pontuacao
          }
        </td>
        <td className='border-0'>{pontuacaoMaxima}</td>
        <td className='border-0'>
          {
            resultadoDoGrupoEmPorcentagem === 'NaN'
              ? 'NA'
              : `${resultadoDoGrupoEmPorcentagem}%`
          }
        </td>
      </tr>
    </React.Fragment>
  );
}

export default ResultadoAgrupadoPorGrupo;
